import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { SectionHeader } from '../components/SectionHeader';
import { SectionInfoBanner } from '../components/SectionInfoBanner';
import { StoreTabFooter } from '../components/StoreTabFooter';
import { SS_OUTLINED_INPUT, ssFieldSx, grid2 } from '../storeSettingsConstants';

export function DeliveryAgreementSection({ meta, form, updateDeliveryAgreement, tabFooterProps }) {
  const minAmount = String(form.delivery_agreement_fees.minimumAmountSpend ?? '').trim();
  const kitchenPercent = String(
    form.delivery_agreement_fees.percentageToPay_byKitchen ?? ''
  ).trim();
  const showDeliveryPreview = minAmount !== '' || kitchenPercent !== '';

  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <div style={grid2}>
        <div>
          <TextField
            id='agreement_min_spend'
            className={SS_OUTLINED_INPUT}
            size='small'
            label='Minimum order amount'
            value={form.delivery_agreement_fees.minimumAmountSpend}
            onChange={(e) => updateDeliveryAgreement('minimumAmountSpend', e.target.value)}
            inputProps={{ inputMode: 'decimal', min: 0, max: 999 }}
            InputProps={{
              startAdornment: <InputAdornment position='start'>$</InputAdornment>,
            }}
            variant='outlined'
            sx={ssFieldSx}
          />
          <p className='store-settings-helper-text'>
            Order must meet this amount to qualify for a delivery discount.
          </p>
        </div>
        <div>
          <TextField
            id='agreement_kitchen_pct'
            className={SS_OUTLINED_INPUT}
            size='small'
            label='Restaurant pays (% of fee)'
            value={form.delivery_agreement_fees.percentageToPay_byKitchen}
            onChange={(e) => updateDeliveryAgreement('percentageToPay_byKitchen', e.target.value)}
            inputProps={{ inputMode: 'decimal', min: 0, max: 100 }}
            InputProps={{
              endAdornment: <InputAdornment position='end'>%</InputAdornment>,
            }}
            variant='outlined'
            sx={ssFieldSx}
          />
          <p className='store-settings-helper-text'>
            Percentage of the delivery fee covered by the restaurant.
          </p>
        </div>
      </div>
      {showDeliveryPreview && (
        <>
          <p
            className='store-settings-helper-text'
            style={{ marginTop: 8, marginBottom: 10, fontSize: 13 }}
          >
            Below is what user sees while ordering.
            <span className='store-settings-example-preview'>
              {' '}
              <span className='store-settings-example-preview__label'> &nbsp; Example &nbsp;</span>
              <img
                src='/images/delivery.png'
                alt='Delivery agreement example'
                className='store-settings-example-preview__image'
              />
            </span>
          </p>
          <div
            style={{
              marginBottom: 14,
              background: '#f9f4ee',
              border: '1px solid #eadbc7',
              borderRadius: 14,
              padding: '14px 16px',
            }}
          >
            <span style={{ fontSize: 15, fontWeight: 600, color: '#9a6134', letterSpacing: 0.1 }}>
              {kitchenPercent || '0'}% off delivery fee when you spend ${minAmount || '0'} or more
            </span>
          </div>
        </>
      )}

      <StoreTabFooter tabId='4' {...tabFooterProps} />
    </>
  );
}
